import { DataModel } from "common/models/utility-models/base-model";

export class InternshipStudentListModel extends DataModel{
  created: any = '';
  modified: any = '';
  is_delete: any = 0;
  studentId: any = '';
  studentSemester: any = '';
  considerYear: any = '';
  isInvited: any = 0;
  isReinvited: any = 0;
  internshipInviteDate: any = '';
  internshipReinviteDate: any = '';
  isStudentAvailable: any = 0;
  studentAvailabilityResponseDate: any = '';
  isExternalCompanyForInternship: any = 0;
  externalCompanyName: any = '';
  externalCompanyLocation: any = '';
  studentExpectedInternshipStartDate: any = '';
  studentExpectedInternshipEndDate: any = '';
  studentExamStartDate: any = '';
  studentExamEndDate: any = '';
  studentSummerVacationStartDate: any = '';
  studentSummerVacationEndDate: any = '';
  studentAvailabilityRemark: any = '';
  isInternshipAssigned: any = 0;
  internshipAssignedDate: any = '';
  internshipModifiedDate: any = '';
  internshipUnassignedDate: any = '';
  internshipUnassignedReason: any = '';
  isInternshipTerminated: any = 0;
  internshipTerminatedReason: any = '';
  internshipTerminatedDate: any = '';
  internshipCode: any = '';
  internshipTitle: any = '';
  internshipStartDate: any = '';
  internshipEndDate: any = '';
  internshipCompanyId: any = '';
  internshipCompanyLocationId: any = '';
  internshipCompanyMentorId: any = '';
  internshipProjectName: any = '';
  accommodationAddress: any = '';
  accommodationContactPerson: any = '';
  guideName: any = '';
  guideEmail: any = '';
  guideMobile: any = '';
  hrName: any = '';
  hrEmail: any = '';
  hrMobile: any = '';
  isStudentJoined: any = 0;
  studentJoinStatusUpdateDate: any = '';
  isStudentContinued: any = 0;
  studentFeedbackDate: any = '';
  reasonForNotJoined: any = '';
  reasonForNotContinued: any = '';
  feedbackToInternshipByStudent: any = '';
  feedbackToMentorByStudent: any = '';
  rateToInternshipByStudent: any = '';
  rateToMentorByStudent: any = '';
  thingsLikeDuringInternship: any = '';
  improvingAreaForInternship: any = '';
  attendenceByMentor: any = '';
  internshipStatusByMentor: any = '';
  studentJoinDateByMentor: any = '';
  studentCompletedDateByMentor: any = '';
  mentorFeedbackDate: any = '';
  internshipCertificateFilename: any = '';
  isInternshipCertyVerified: any = 0;
  isResendCerty: any = 0;
  reasonForRejectInternshipCerty: any = '';
  certyUploadDate: any = '';
  certyVerifySatusDate: any = '';
  name: any = '';
  email: any = '';
  mobile_number: any = '';
  branch_id: any = '';
  branchName: any = '';
  region_id: any = '';
  state_id: any = '';
  StateName: any = '';
  batchId: any = '';
  batch_number: any = '';
  name_of_college: any = '';
  first_year_score: any = 0;
  second_year_score: any = 0;
  third_year_score: any = 0;
  fourth_year_score: any = 0;
  fifth_year_score: any = 0;
  gender: any = '';
  district_id: any = '';
  region: any = '';
  district: any = '';
}